<template>
  <div class="content">
    <div>
      <div class="new-modal-error-icon">!</div>
      <h3 class="new-modal-generic-error-title">{{ translations.seekGenericErrorTitle }}</h3>
      <p class="new-modal-description">
        {{ translations.seekGenericErrorDescription }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "GenericErrorModal",
  computed: {
    translations(){
      return this.$store.state.translations.data;
    }
  },
};
</script>
